export default __webpack_public_path__ + "static/media/sort_teal.88fe26d2.svg";